import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/policy/img/block1_背景2.png")